import { render } from "./Localization.vue?vue&type=template&id=5af34932"
import script from "./Localization.vue?vue&type=script&lang=js"
export * from "./Localization.vue?vue&type=script&lang=js"
script.render = render

export default script